import React from 'react'
import PropTypes from 'prop-types'
import { Box, CircularProgress, Typography } from '@material-ui/core'
import { Clock as ClockIcon } from 'react-feather'
import TableLogs from 'components/TableLogs'
import useStyles from './styles'

const ActivityLogsTab = ({ logs, logsLoading }) => {
  const classes = useStyles()

  if (logsLoading) {
    return (
      <Box display="flex" justifyContent="center" pt={4}>
        <CircularProgress size={24} />
      </Box>
    )
  }

  if (logs.length === 0) {
    return (
      <Box className={classes.empty}>
        <ClockIcon size={32} />
        <Typography variant="body2">Nenhum histórico registrado</Typography>
      </Box>
    )
  }

  return <TableLogs dponetAudits={logs} entityName="task" object={{}} />
}

ActivityLogsTab.propTypes = {
  logs: PropTypes.array.isRequired,
  logsLoading: PropTypes.bool.isRequired,
}

export default ActivityLogsTab
